import React from 'react';

import { AdditionalPackage } from '@react/Pages/AccountSettingsPage/PricingPlanPage/AdditionalPackage/AdditionalPackage';

import './AdditionalPackages.scss';

export interface Package {
  name: string;
  description: string;
  isEnabled: boolean;
}

export interface AdditionalPackagesProps {
  packages: Package[];
}

export const AdditionalPackages = ({ packages }: AdditionalPackagesProps) => (
  <div className="additional-packages">
    <h3 className="additional-packages__title">{t('label.additional-packages')}</h3>

    <div className="additional-packages__list">
      {packages.map(({ name, description, isEnabled }) => (
        <AdditionalPackage key={name} name={name} description={description} isEnabled={isEnabled} />
      ))}
    </div>
  </div>
);
